module.exports = __webpack_public_path__ + "static/media/Entreprise-Analyse-Immobilier-Vaud.d50b9b52.jpg";